import React, { useCallback, ComponentProps } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { hrefFor } from '../../routers';
import { AmazonPayButton } from '../PaymentSourceButton';

type Props = Omit<ComponentProps<typeof AmazonPayButton>, 'onSelect'>;

export const CheckoutAmazonPayButton: React.FC<Props> = props => {
  const location = useLocation();
  const history = useHistory();

  const handleOnClick = useCallback(() => {
    if (location.pathname !== hrefFor.CheckoutPage()) {
      history.push(hrefFor.CheckoutPage());
    }
  }, [history, location.pathname]);

  return <AmazonPayButton {...props} handleRedirect={handleOnClick} />;
};
